import api from '@/services/api'

const createAd = (path, ad) => api
  .post(path, ad)
  .then(({ data }) => data)

const deleteAd = path => api
  .delete(path)
  .then(({ data }) => data)

const getAds = path => api
  .get(path)
  .then(({ data }) => data)

const updateAd = createAd

export default {
  createAd,
  deleteAd,
  getAds,
  updateAd
}
